import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-grid p-fluid p-px-5" }
const _hoisted_2 = { class: "p-col-6" }
const _hoisted_3 = { class: "p-field" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "shortDescription" }, "¿Necesito prepararme?", -1)
const _hoisted_5 = { class: "p-field" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "preKnowledge" }, "Conocimientos Previos", -1)
const _hoisted_7 = { class: "p-field" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "correlatives" }, "Correlatividades", -1)
const _hoisted_9 = { class: "p-col-6" }
const _hoisted_10 = { class: "p-field" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "postSkillsInput" }, "Después del curso podrás", -1)
const _hoisted_12 = { class: "p-inputgroup" }
const _hoisted_13 = { class: "p-mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_CoursePlanSelector = _resolveComponent("CoursePlanSelector")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ChTag = _resolveComponent("ChTag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_Textarea, {
          id: "shortDescription",
          type: "text",
          rows: "5",
          cols: "80",
          value: _ctx.requeriments,
          onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:requeriments', $event.target.value))),
          autoResize: true
        }, null, 8, ["value"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_Textarea, {
          id: "preKnowledge",
          type: "text",
          value: _ctx.preKnowledge,
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:preKnowledge', $event.target.value))),
          rows: "5",
          cols: "80",
          autoResize: true
        }, null, 8, ["value"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_CoursePlanSelector, {
          id: "correlatives",
          coursePlans: _ctx.coursePlans
        }, null, 8, ["coursePlans"])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_InputText, {
            id: "postSkillsInput",
            modelValue: _ctx.postSkillInput,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.postSkillInput = $event)),
            type: "text",
            placeholder: "Agregar un nuevo 'podrás'"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_Button, {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.createPostSkills())),
            class: "p-button-outlined",
            label: "Agregar"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.postSkillsRef, (skill, index) => {
          return (_openBlock(), _createBlock(_component_ChTag, {
            key: skill,
            showRemoveButton: true,
            onOnRemove: ($event: any) => (_ctx.removeElement(index)),
            class: "p-pb-2 p-pt-2 p-col-10 p-ml-5 p-mb-2"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(skill), 1)
            ]),
            _: 2
          }, 1032, ["onOnRemove"]))
        }), 128))
      ])
    ])
  ]))
}